import { createAction } from 'redux-actions';
import { ELEMENT_SELECT_MODES } from 'constants/feature/modes-constants';
import { ELEMENT_HIGHLIGHT_STATES } from 'constants/feature/tieout-element-constants';

const replaceSelectedElementsContentPanel = createAction(
  'REPLACE_SELECTED_ELEMENTS_CONTENT_PANEL',
);
const selectElementContentPanel = createAction('SELECT_ELEMENT_CONTENT_PANEL');
export const deselectElementContentPanel = createAction(
  'DESELECT_ELEMENT_CONTENT_PANEL',
);
export const clearContentHighlightSelector = createAction(
  'CLEAR_CONTENT_HIGHLIGHT_SELECTOR',
);

export const selectElementFromElementSearch =
  ({ elementId, firstSearch }) =>
  (dispatch, getState) => {
    const { elementDetails } = getState().data.elementPanel;
    const { selectMode } = getState().ui.statementPage.modes;
    if (
      selectMode !== ELEMENT_SELECT_MODES.RANGE &&
      (selectMode === ELEMENT_SELECT_MODES.BATCH_WITH_BANNER ||
        selectMode !== ELEMENT_SELECT_MODES.BATCH)
    ) {
      // skip when in range or batch select mode
      dispatch(
        replaceSelectedElementsContentPanel({
          elementIds: [elementId],
          color: firstSearch
            ? ELEMENT_HIGHLIGHT_STATES.DEFAULT
            : ELEMENT_HIGHLIGHT_STATES.PANEL_SELECTED,
        }),
      );
      if (elementDetails.id) {
        dispatch(
          selectElementContentPanel({
            elementIds: elementDetails.id,
            color: ELEMENT_HIGHLIGHT_STATES.DEFAULT,
          }),
        );
      }
    }
  };
